import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockBehaviorDataType } from "../../../../../enums/SDKDocsBlockBehaviorDataType";
import { DocsBlockBehaviorSelectionType } from "../../../../../enums/SDKDocsBlockBehaviorSelectionType";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.files";
const name = "File upload";
const icon = "https://cdn-assets.supernova.io/blocks/icons/files.svg";
const descriptionShort = "Display attachments for download";
const keywords = ["files", "attachments", "download", "upload"];
const descriptionFull = "Display attachments for download";
const docsUrl = "https://learn.supernova.io/file-upload-block";
/**
 * 2. Block properties
 */
const properties = {
    files: b.fileProperty({
        id: "files",
        name: "Files",
        options: {
            renderLayoutAs: "iconOnLeft",
        },
        variants: {
            iconOnTop: {
                renderLayoutAs: "iconOnTop",
            },
            iconOnLeft: {
                renderLayoutAs: "iconOnLeft",
            },
        },
    }),
};
/**
 * 3. Block variants
 */
const variants = [
    b.variantUsingDefaultLayout({
        id: "iconOnTop",
        name: "Icon on top",
        image: "https://cdn-assets.supernova.io/blocks/variants/files-icon-on-top.svg",
        properties: [properties.files],
        maxColumns: 4,
    }),
    b.variantUsingDefaultLayout({
        id: "iconOnLeft",
        name: "Icon on left",
        image: "https://cdn-assets.supernova.io/blocks/variants/files-leading-icon.svg",
        properties: [properties.files],
        maxColumns: 2,
    }),
];
/**
 * 4. Block item
 */
const blockItem = b.multiVariantItem({
    properties: [properties.files],
    variants,
});
/**
 * 5. Block definition
 */
const block = b.dataBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    searchKeywords: keywords,
    dataType: DocsBlockBehaviorDataType.file,
    selectionType: DocsBlockBehaviorSelectionType.entity,
    item: blockItem,
    onboarding: b.onboarding({
        helpText: descriptionFull,
        documentationLink: docsUrl,
    }),
    appearance: {
        isBordered: false,
    },
});
/** 6. Block export */
export { block as Files };
